import { EPlaces } from "../enums/Places";
import { ERequestMethods } from "../enums/RequestMethod";
import { request } from "../libs/request";
import { IPlace } from "../types/Places";
import { ListResponseData } from "../types/requests";

function getPlaces() {
  return request<ListResponseData<IPlace>>({
    method: ERequestMethods.GET,
    url: EPlaces.MAIN,
  });
}

function getPlacesById(id: string) {
  return request<IPlace>({
    method: ERequestMethods.GET,
    url: EPlaces.BY_ID(id),
  });
}

function createPlaces(data: IPlace) {
  return request({
    method: ERequestMethods.POST,
    url: EPlaces.MAIN,
    data,
  });
}

function updatePlaces(id: string, data: Partial<IPlace>) {
  return request({
    method: ERequestMethods.PATCH,
    url: EPlaces.BY_ID(id),
    data,
  });
}

function deletePlaces(id: string) {
  return request({
    method: ERequestMethods.DELETE,
    url: EPlaces.BY_ID(id),
  });
}

function importPlaces(data: FormData) {
  return request({
    method: ERequestMethods.POST,
    url: EPlaces.IMPORT,
    data,
  });
}

const PlacesRepository = Object.freeze({
  getPlaces,
  getPlacesById,
  createPlaces,
  updatePlaces,
  deletePlaces,
  importPlaces,
});

export default PlacesRepository;